var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-toolbar',{attrs:{"flat":"","color":"transparent"}},[(_vm.page.icon)?_c('v-icon',[_vm._v(_vm._s(_vm.page.icon))]):_vm._e(),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.__(_vm.page.title)))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }